import dayjs from 'dayjs';

import summerImage from '@/assets/images/seasonal/login-summer-full.png';
import winterImage from '@/assets/images/seasonal/login-winter-full.png';

/**
 * Utility to determine the current season and return the appropriate seasonal image
 * using dayjs quarterOfYear plugin
 */

/**
 * Returns the appropriate seasonal login background image based on current quarter
 * Quarter 1 (Jan-Mar): Winter images
 * Quarters 2-4 (Apr-Dec): Summer images
 */
export function getSeasonalLoginImage(): string {
  const currentQuarter = dayjs().quarter();
  return currentQuarter === 1 ? winterImage : summerImage;
}
